const ABFieldDateCore = require("../../core/dataFields/ABFieldDateCore");
module.exports = class ABFieldDate extends ABFieldDateCore {};
